export default __webpack_public_path__ + "static/media/kafar_vnl.42dc87df.jpg";